module.exports = __webpack_public_path__ + "img/JOINT_ATTACK_A1014.023560b6.png";